const CHAVER_DESCRIPTIONS = {
  'lead-growth-month': [
    { title: 'פגישת ייעוץ אישית', subTitle: 'עם יועץ פיננסי מומחה (עובד רייזאפ) לעמיתי חבר' },
    { title: 'תוכנית כלכלית מותאמת אישית', subTitle: 'לפי המטרות והצרכים שלכם' },
    { title: 'חודש ליווי בוואטסאפ', subTitle: 'מעקב אחר משימות ויעדים' },
    { title: 'בונוס: 3 חודשים באפליקציית רייזאפ\u00A0בחינם', subTitle: '(בשווי 165 ₪)' },
  ],
  'lead-growth-half-year': [
    { title: '3 פגישות ייעוץ אישיות', subTitle: 'עם יועץ פיננסי מומחה (עובד רייזאפ) לעמיתי חבר' },
    { title: 'תוכנית כלכלית מותאמת אישית', subTitle: 'ודיוק שלה לאורך הדרך' },
    { title: 'חצי שנה ליווי בוואטסאפ', subTitle: 'מעקב שוטף אחר משימות ויעדים' },
    { title: 'בונוס: 6 חודשים באפליקציית רייזאפ\u00A0בחינם', subTitle: '(בשווי 330 ₪)' },
  ],
  'lead-growth-year': [
    { title: '6 פגישות ייעוץ אישיות', subTitle: 'עם יועץ פיננסי מומחה (עובד רייזאפ) לעמיתי חבר' },
    { title: 'תוכנית צמיחה לשנה שלמה', subTitle: 'שמתעדכנת איתכם לאורך הדרך' },
    { title: 'שנת ליווי בוואטסאפ', subTitle: 'מעקב שוטף אחר משימות ויעדים' },
    { title: 'בונוס: 12 חודשים באפליקציית רייזאפ\u00A0בחינם', subTitle: '(בשווי 528 ₪)' },
  ],
};

const ADVISORY_DESCRIPTIONS = {
  'advisory-growth-month': [
    { title: 'פגישת ייעוץ אישית', subTitle: 'עם יועץ פיננסי מומחה (עובד רייזאפ)' },
    { title: 'תוכנית כלכלית מותאמת אישית', subTitle: 'לפי המטרות והצרכים שלכם' },
    { title: 'חודש ליווי בוואטסאפ', subTitle: 'מעקב אחר משימות ויעדים' },
    { title: 'בונוס: 3 חודשים באפליקציית רייזאפ\u00A0בחינם', subTitle: '(בשווי 165 ₪)' },
  ],
  'advisory-growth-half-year': [
    { title: '3 פגישות ייעוץ אישיות', subTitle: 'עם יועץ פיננסי מומחה (עובד רייזאפ)' },
    { title: 'תוכנית כלכלית מותאמת אישית', subTitle: 'ודיוק שלה לאורך הדרך' },
    { title: 'חצי שנה ליווי בוואטסאפ', subTitle: 'מעקב שוטף אחר משימות ויעדים' },
    { title: 'בונוס: 6 חודשים באפליקציית רייזאפ\u00A0בחינם', subTitle: '(בשווי 330 ₪)' },
  ],
  'advisory-growth-year': [
    { title: '6 פגישות ייעוץ אישיות', subTitle: 'עם יועץ פיננסי מומחה (עובד רייזאפ)' },
    { title: 'תוכנית צמיחה לשנה שלמה', subTitle: 'שמתעדכנת איתכם לאורך הדרך' },
    { title: 'שנת ליווי בוואטסאפ', subTitle: 'מעקב שוטף אחר משימות ויעדים' },
    { title: 'בונוס: 12 חודשים באפליקציית רייזאפ\u00A0בחינם', subTitle: '(בשווי 528 ₪)' },
  ],
};

export const PAYMENT_FLOWS = {
  chaver: {
    flow: 'chaver',
    storeNamespace: 'leadPayment',
    routeBase: '/h-offering-payment',
    offeringIds: ['lead-growth-month', 'lead-growth-half-year', 'lead-growth-year'],
    subHeadline: 'תוכניות ליווי לעמיתי חבר:',
    descriptions: CHAVER_DESCRIPTIONS,
  },
  advisory: {
    flow: 'advisory',
    storeNamespace: 'advisoryPayment',
    routeBase: '/advisory-offering-payment',
    offeringIds: ['advisory-growth-month', 'advisory-growth-half-year', 'advisory-growth-year'],
    subHeadline: 'תוכניות ליווי:',
    descriptions: ADVISORY_DESCRIPTIONS,
  },
};

export function paymentFlowConfig(flowName) {
  return PAYMENT_FLOWS[flowName];
}
